module.exports = __webpack_public_path__ + "static/obvious_4-d62d059edbc0a2d98c01752354bd6d43.jpg";